import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import LaunchIcon from '@material-ui/icons/Launch';
import history from '../../../../history';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';

const ListPatientsPendingInvoiceTableActions = ({ data }) => {

    useEffect(() => {

    }, []);

    const getAdmision = (id_admision) => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({ id_admision: id_admision })
            }).then(response => {
                return response.json();
            }).then(data => {
                resolve(data);
            }).catch((error) => {
                console.error('Error:', error);
                resolve({ existe: false });
            });
        });
    }

    const goToAdmision = (id_admision) => {
        getAdmision(id_admision).then((data) => {
            if (data.existe == true) {
                history.push({
                    pathname: process.env.PUBLIC_URL + '/assitencial/add-admission',
                    state: {
                        caidas: data.contenido[0].caidas,
                        dataPatient: data.contenido[0],
                        id_admision: data.contenido[0].id_admision,
                        recibo_pago: data.contenido[0].pago,
                        patient_pending: true
                    }
                });
            }
        }).catch((err) => {
            console.error(err);
        });
    }

    const loadBilling = (id_admision) => {
        return new Promise((resolve, reject) => {
            var dataBilling = { id_admision: id_admision };
            fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/admisionpaga', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataBilling)
            }).then(response => {
                return response.json();
            }).then(data => {
                resolve(data.contenido[0]);
            }).catch((e) => {
                console.error(e);
                reject(e);
            });
        })
    }

    const loadPlan = (billing, dataAdmision) => {
        var dataClose = { id_plan: billing.id_plan };
        fetch(process.env.REACT_APP_PUBLIC_URL + 'plan/consultar_plan', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataClose)
        }).then(response => {
            return response.json();
        }).then(data => {
            loadDataProfile(billing, data.contenido[0], dataAdmision);
        }).catch((e) => {
            console.error(e);
        });
    }

    const goToCashReceipt = async (id_admision, id_admision_padre) => {
        let id_admision_query = id_admision_padre != null && id_admision_padre != undefined ? id_admision_padre : id_admision;
        getAdmision(id_admision_query).then((data) => {
            if (data.existe == true) {
                loadBilling(data.contenido[0].id_admision).then((billingData) => {
                    loadPlan(billingData, data.contenido[0]);
                });
            }
        }).catch((err) => {
            console.error(err);
        })
    }

    const loadDataProfile = async (billing, plan, dataAdmision) => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'clinica/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            return response.json();
        }).then(resp => {
            if (resp.length > 0) {
                if (resp.length > 0) {
                    history.push({
                        pathname: process.env.PUBLIC_URL + '/assitencial/receipt-admission',
                        state: {
                            dataPatient: dataAdmision,
                            dataCashReceipt: billing,
                            dataPlan: plan,
                            dataProfile: resp[0],
                            state: null,
                            datePrevious: dataAdmision.fecha,
                            indexPage: 0,
                            pendingPatient: true
                        }
                    });
                }
                //infoPrintReciept(billing, plan, resp[0], dataAdmision.id_admision);
            }
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    const infoPrintReciept = async (billing, plan, profile, id_admision) => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/consultar-recibos-por-admision?id_admision=' + id_admision, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            return response.json();
        }).then(res => {
            reciptPdf(billing, plan, profile, res);
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    //Abre el Recibo de Caja Original
    const validateBilling = async (id_admision) => {
        let admisionDataFetch = await getAdmision(id_admision);

        if(admisionDataFetch.existe == true)
        {
            let admisionData = admisionDataFetch.contenido[0];
            if (admisionData.id_admision_cita_padre != null && admisionData.id_admision_cita_padre != undefined) {
                let fatherAdmission = await loadFatherAdmission(admisionData.id_admision_cita_padre);
                await loadBilling(fatherAdmission.id_admision).then((billing) => {
                    if (typeof billing === 'string') {
                        history.push({
                            pathname: process.env.PUBLIC_URL + '/assitencial/receipt-admission',
                            state: {
                                dataPatient: fatherAdmission,
                                dataCashReceipt: null,
                                dataPlan: null,
                                dataProfile: null,
                                state: null,
                                datePrevious: admisionData.fecha,
                                indexPage: 0,
                                pendingPatient: true
                            }
                        });
                    }
                    else {
                        loadPlan(billing, fatherAdmission);
                    }
                }).catch((e) => {
                    console.error(e);
                });
            }
            else {
                await loadBilling(admisionData.id_admision).then((billing) => {
                    if (typeof billing === 'string') {
                        history.push({
                            pathname: process.env.PUBLIC_URL + '/assitencial/receipt-admission',
                            state: {
                                dataPatient: admisionData,
                                dataCashReceipt: null,
                                dataPlan: null,
                                dataProfile: null,
                                state: null,
                                datePrevious: admisionData.fecha,
                                indexPage: 0,
                                pendingPatient: true
                            }
                        });
                    }
                    else {
                        loadPlan(billing, admisionData);
                    }
                }).catch((e) => {
                    console.error(e);
                });
            }
        }

       
    }

    return (<Fragment>
        <td role="cell">
            <Tooltip title="Editar datos del Paciente">
                <IconButton className="text-success" style={{ fontSize: '15px' }} onClick={() => {
                    goToAdmision(data.data.original.id_admision);
                }}>
                    <LaunchIcon style={{ color: '#000' }} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Recibo de Caja">
                <IconButton className="text-success" style={{ fontSize: '15px' }} onClick={() => {
                    //goToCashReceipt(data.data.original.id_admision, data.data.original.id_admision_padre);
                    validateBilling(data.data.original.id_admision);
                }}>
                    <MonetizationOnIcon style={{ color: '#000' }} />
                </IconButton>
            </Tooltip>

        </td>
    </Fragment>)
}

export default ListPatientsPendingInvoiceTableActions;